// extracted by mini-css-extract-plugin
export default {"tooltip":"TreeMap_tooltip__QufRc","tooltip__text":"TreeMap_tooltip__text__ha1JP"};